import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { useModel } from "../../../models"
import { filterTree } from "../../../utils/decoder"
import { formatNum, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const TableHeader = () => {
    const [{ CustomerTotal, selectedCustomerRow }, { init }] = useModel("customerBill")

    const history = useHistory();
    const onAdd = () => {
        init();
        history.push({ pathname: "/sale/order/detail", state: { id: "3-1-1" } })
    }
    const onDetail = () => {
        init();
        history.push({ pathname: "/bill/customer/detail", state: { id: "5-1-1" } })
    }


    return (
        <div style={{ margin: "0 0 8px", display: "flex" }}>
            <div style={{ width: "460px", paddingTop: "6px" }}>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_VW}>
                    <Button disabled={!!!selectedCustomerRow} className="margin-left-8" onClick={onDetail}>账单详情</Button>
                </YhAuth>
            </div>
            <div className="detail-list-statistic" style={{ textAlign: "right" }}>
                <span className="margin-left-8 color-blue">已用授信额度合计：{CustomerTotal.usedCreditLineTotal}</span>
                <span className="margin-left-16 color-blue">可用额度合计：{CustomerTotal.availableCreditTotal}</span>
                <span className="margin-left-16 color-blue">剩余总金额合计：{CustomerTotal.remainingAmountTotal}</span>
            </div>
        </div>
    )
}
export default function () {
    const [{ customerTypeDict },] = useModel("cmDict");
    const [{
        CustomerList,
        SearchParams,
        PageInfo,
        selectedCustomerRow,
        selectedCustomeRowKeys
    }, {
        setSelectedCustomerRow,
        setSelectedCustomeRowKeys,
        loadCustomerList
    }] = useModel("customerBill")
    useEffect(() => {
        loadCustomerList({ showMsg: false, data: {} })
    }, [])
    const columns = [
        {
            title: '客户名称',
            dataIndex: 'customerName',
            align: 'left',
        },
        {
            title: '客户编码',
            dataIndex: 'customerCode',
            render: text => <span>{text}</span>,
        },
        {
            title: '客户类型',
            dataIndex: 'customerType',
            render: (text, record, index) => <>{filterTree(customerTypeDict, text)}</>,

        },
        {
            title: '授信额度',
            dataIndex: 'creditLine',
            render: text => formatNum(text)
        },
        {
            title: '已用授信额度',
            dataIndex: 'usedCreditLine',
        },
        {
            title: '可用额度',
            dataIndex: 'availableCredit',
        },
        {
            title: '剩余总金额',
            dataIndex: 'remainingAmount',
        },
        {
            title: '欠款总额',
            dataIndex: 'arrears',
        },
        {
            title: '抹零总额',
            dataIndex: 'omitAmount',
        },
    ];
    const onPageChange = (page, pageSize) => {
        const params = { ...SearchParams };
        params.pageNum = page;
        params.pageSize = pageSize;
        loadCustomerList({ data: params });
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={CustomerList}
                // rowKey={record => record.customerAddress}
                bordered
                pagination={{
                    // hideOnSinglePage: true,
                    showSizeChanger: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: PageInfo.total,
                    current: PageInfo.pageNum,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setSelectedCustomerRow(selectedRows[0]);
                        setSelectedCustomeRowKeys(selectedRowKeys)
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled User',
                        name: record.name,
                    }),
                    selectedRowKeys: selectedCustomeRowKeys
                }}
                onRow={(record, index) => {
                    return {
                        onClick: event => {
                            if (selectedCustomerRow && selectedCustomerRow.key == record.key) {
                                setSelectedCustomerRow(null);
                                setSelectedCustomeRowKeys([])
                            } else {
                                setSelectedCustomerRow(record);
                                setSelectedCustomeRowKeys([record.key])
                            }
                        }, // 点击行
                    };
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    );
}